import ErrorManager from '@/common/utils/ErrorManager';
import { TypeItems } from '@/models/TypeItems';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';
import { RootState } from '@/plugins/store';
import { ActionTree, Commit, MutationTree } from 'vuex';
import TypeService from '../../services/TypeService';
import { TYPE } from '../mutation-types';
import { getters } from './type-getters';

export interface TypeState {
    types: TypeItems[];
    isLoading: boolean;
    error: boolean;
    filter: string;
}

interface TypeActionType {
    commit: Commit;
    state: TypeState;
}

export enum TypeActions {
    GET_TYPE = 'GET_TYPE',
}

const state = (): TypeState => ({
    types: [],
    isLoading: false,
    error: false,
    filter: '',
});

const actions: ActionTree<TypeState, RootState> = {
    async [TypeActions.GET_TYPE]({ commit }: TypeActionType, chantierId: number): Promise<void> {
        commit(TYPE.SET_LOADING, true);
        TypeService.getTypes(chantierId)
            .then(async response => {
                if (response !== undefined || response.status !== undefined) {
                    if (response.status !== 200) {
                        commit(TYPE.SET_ERROR, true);
                        commit(TYPE.SET_LOADING, false);
                        commit(
                            `errorToaster/${ERROR.SET_MESSAGE}`,
                            await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                            { root: true }
                        );
                    }
                    const typeData: TypeItems = response.data;
                    commit(TYPE.SET_ITEMS, typeData);
                    commit(TYPE.SET_LOADING, false);
                } else {
                    commit(TYPE.SET_ERROR, true);
                    commit(TYPE.SET_LOADING, false);
                    commit(
                        `errorToaster/${ERROR.SET_MESSAGE}`,
                        await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                        { root: true }
                    );
                }
            })
            .catch(async error => {
                commit(TYPE.SET_ERROR, true);
                commit(TYPE.SET_LOADING, false);
                commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
            });
    },
};

const mutations: MutationTree<TypeState> = {
    [TYPE.SET_LOADING](state: TypeState, isLoading: boolean): void {
        state.isLoading = isLoading;
    },
    [TYPE.SET_ERROR](state: TypeState, error: boolean): void {
        state.error = error;
    },
    [TYPE.SET_ITEMS](state: TypeState, items: TypeItems[]): void {
        state.types = items;
    },
};
const types = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
export default types;
